import { actions as ACTION } from "./types";
import axios from "axios";

const actions = {
  [ACTION.GSNACKBAR_COMMIT_COMMON]: async (store, { message, type }) => {
    const { state } = store;
    try {
      state.common.gSnackbar.message = message;
      state.common.gSnackbar.type = type;

      if (type == "success" || type == "error") {
        setTimeout(() => {
          state.common.gSnackbar.message = "";
          state.common.gSnackbar.type = "";
        }, 2000);
      }
    } catch (error) {
      state.common.gSnackbar.message = "";
      state.common.gSnackbar.type = "";
    }
  },
  
  [ACTION.GSNACKBAR_CLOSE]: async ({state}) => {
    state.common.gSnackbar.message = "";
    state.common.gSnackbar.type = "";
  },

  [ACTION.GLOADING_COMMIT_COMMON]: async (store, { text, size, active }) => {
    const { state } = store;
    try {
      state.common.gLoading.text = text;
      state.common.gLoading.active = active;
      state.common.gLoading.size = size;
    } catch (error) {
      state.common.gLoading.text = "";
      state.common.gLoading.active = false;
      state.common.gLoading.size = "large";
    }
  },

  [ACTION.TRACK_EVENT]: (_, params) => {
    if (!process.env.VUE_APP_ES_TRACKING_ENDPOINT) return;
    const timeNowInt = Date.now();
    const timeNow = new Date(timeNowInt);

    const document = {
      created_at: timeNow.toISOString(),
      path: window.location.href,
      shopify_domain: window.___gemShopInfo.shopifyDomain,
      merchant_email: window.___gemShopInfo.email,
      merchant_created_at: window.___gemShopInfo.createdAt,
      merchant_plan: window.___gemShopInfo.plan,
      ...params,
    }

    axios.post(process.env.VUE_APP_ES_TRACKING_ENDPOINT, document);
  }
};

export default actions;
